export default "__VITE_ASSET__DnWdGNHE__"